var base = require('settings/teams');

Vue.component('spark-teams', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams.js